class Html2Pdf {

    constructor(element, filename) 
    {
        this.element = $(element)[0];
        this.filename = filename;
    }   

    downloadPdf() {

        const options = {
            filename: this.filename,
            margin: 0,
            image: { type: 'jpeg', quality: 0.98 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: 'avoid-all' }
        };

        html2pdf().
            set(options).
            from(this.element).
            save(this.filename + '.pdf');
    }
}